
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NVAbbreviation',
  props: {
    href: {
      type: String,
      default: 'https://www.nvschade.nl/begrippen/',
    },
  },
});
